import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../api.service';
import { UserOrganization } from '../models/user-organization';

@Component({
  selector: 'app-organization-users',
  templateUrl: './organization-users.component.html',
  styleUrls: ['./organization-users.component.css']
})
export class OrganizationUsersComponent implements OnInit {
  organizationUsers: UserOrganization[] = [];

  constructor(private api: ApiService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    
    this.route.queryParams.subscribe(params => {
      const orgId = params['orgId'];
      this.api.getOrganizationUsers(orgId).subscribe((data: UserOrganization[]) => {
        this.organizationUsers = data;
      });
    });
  }

}
